import React from 'react';
import { Spin } from 'antd';
import styles from './loader.module.css';

const loader = (props) => {
  
  if (props.error) {
    return <div>Error! <button onClick={ props.retry }>Retry</button></div>;
  } 
  else if (props.pastDelay) {
    return  <div className={styles['loader-wrapper']}>
    <div className={styles['loader-content']}>
      <Spin tip="Loading.." />
    </div>
  </div>;
  } else {
    return null;
  }
};

export default loader;